<template>
  <div class="downloadBtn">
    <div class="btnlist">
      <!--<a href="https://apps.apple.com/cn/app/nebulabuds/id6480039371" target="_blank">-->
      <a v-for="item in appStoreList" :key="item.id" :href="item.href" @click="downloadApp(item)">
        <img :src="require(`../assets/download/${item.img}`)" />
        <span>{{ item.name }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    appStoreList () {
      return [{
        id: 1,
        name: this.$t('download.apple'),
        href: 'javascript:;',
        img: 'AppStore.png'
      }, {
        id: 2,
        name: this.$t('download.google'),
        href: 'javascript:;',
        img: 'google.png'
      }, {
        id: 3,
        name: this.$t('download.honor'),
        href: 'javascript:;',
        img: 'honor.png'
      }, {
        id: 4,
        name: this.$t('download.android'),
        href: 'javascript:;',
        img: 'anzhuo.png'
      }, {
        id: 5,
        name: this.$t('download.huawei'),
        href: 'javascript:;',
        img: 'huawei.png'
      }, {
        id: 6,
        name: this.$t('download.mi'),
        href: 'javascript:;',
        img: 'mi.png'
      }, {
        id: 7,
        name: this.$t('download.oppo'),
        href: 'javascript:;',
        img: 'oppo.png'
      }, {
        id: 8,
        name: this.$t('download.vivo'),
        href: 'javascript:;',
        img: 'vivo.png'
      }]
    }
  },
  methods: {
    downloadApp (appInfo) {
      switch (appInfo.id) {
        case 1:
          console.log('apple')
          // window.location.href = 'https://apps.apple.com/us/app/nebularec/id6744643148'
          window.open('https://apps.apple.com/us/app/nebularec/id6744643148', '_blank')
          break
        case 2:
          console.log('Play 商店')
          // window.location.href = 'https://play.google.com/store/apps/details?id=com.palmzem.voicerecorder'
          window.open('https://play.google.com/store/apps/details?id=com.palmzem.voicerecorder', '_blank')
          break
        case 3:
          console.log('荣耀应用商店')
          window.open('https://appmarket-h5.cloud.honor.com/h5/share/latest/index.html?shareId=1976936135042260992#/', '_blank')
          // alert(this.$t('download.appstore'))
          break
        case 4:
          console.log('安卓下载')
          window.open('https://cos-rec.nebula-ai.net/apk/rec.apk')
          break
        case 5:
          console.log('华为下载')
          window.open('https://appgallery.huawei.com/app/C114917975', '_blank')
          break
        case 6:
          console.log('小米下载')
          window.open('https://app.xiaomi.com/details?id=com.palmzem.voicerecorder&ref=search', '_blank')
          break
        case 7:
          console.log('oppo下载')
          alert(this.$t('download.appstore'))
          break
        case 8:
          console.log('vivo下载')
          window.open('https://h5.appstore.vivo.com.cn/index.html#/details?search_word=nebularec&search_action=4&app_id=4078061&app_pos=1&source=5&appId=4078061&frompage=searchResultApp&listpos=1', '_blank')
          break
        default:
          alert('敬请期待！')
          console.log('Unknown fruit')
      }
    }
  },
  mounted () {
    console.log('aa')
    // if (this.$i18n.locale === 'en') { this.$i18n.locale = 'zh' } else { this.$i18n.locale = 'en' }
  }
}
</script>
<style scoped>
.downloadBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  padding: 10px;
  width: 100%;
  border-radius: 20px 20px 0 0;
  background-color: #fff
}

.btnlist {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.downloadBtn a {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 5px;
  border: none;
  width: calc(25% - 10px);
  min-width: 160px;
  height: 40px;
  border-radius: 5px;
  background-color: #373737;
}

.downloadBtn a img {
  width: 30px;
}

.downloadBtn a span {
  margin-left: 10px;
  color: #fff;
  font-size: 14px;
}

.downloadBtn a.zhanweiBtn {
  background: none;
}

@media only screen and (max-width: 700px) {
  .btnlist {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .downloadBtn a {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 5px 0 5px;
    width: calc(50% - 10px);
    min-width: 0;
    height: 40px;
    border-radius: 5px;
    background-color: #373737;
  }

  .downloadBtn a img {
    width: 30px;
  }

  .downloadBtn a span {
    margin-left: 5px;
  }

  .zhanweiBtn {
    background: none;
  }
}
</style>
<!-- appStoreList: [{
        id: 1,
        name: '安卓下载',
        href: 'javascript:;',
        img: 'anzhuo.png'
      }, {
        id: 2,
        name: 'OPPO软件商店',
        href: 'javascript:;',
        img: 'oppo.png'
      }, {
        id: 3,
        name: 'VIVO应用商店',
        href: 'javascript:;',
        img: 'vivo.png'
      }, {
        id: 4,
        name: 'Play 商店',
        href: 'javascript:;',
        img: 'google.png'
      }, {
        id: 5,
        name: '小米应用商店',
        href: 'javascript:;',
        img: 'mi.png'
      }, {
        id: 6,
        name: '华为应用市场',
        href: 'javascript:;',
        img: 'huawei.png'
      }, {
        id: 7,
        name: '应用宝',
        href: 'javascript:;',
        img: 'yingyongbao.png'
      }, {
        id: 8,
        name: 'App Store',
        href: 'javascript:;',
        img: 'AppStore.png'
      }] -->
